import moment from 'moment';

export const getDateParams = (searchParams) => {
    let startDate = searchParams.get("startDate")
    let endDate = searchParams.get("endDate")

    return [startDate ? moment(startDate).startOf('day') : moment().subtract(10, 'days').startOf('day'), endDate ? moment(endDate).endOf('day') : moment().endOf('day')]
}

export const getPaginationParams = (searchParams) => {
    return {
        current: searchParams.get("currentPage") ? parseInt(searchParams.get("currentPage")) : 1,
        pageSize: searchParams.get("pageSize") ? searchParams.get("pageSize") : 10,
        pageSizeOptions: ['10', '25', '50', '100', '500', '5000'],
        position: ["topRight"]
    }
}

export const getDefaultPagination = () => {
    return {
        current: 1,
        pageSize: 10000,
        // pageSizeOptions: ['10', '25', '50', '100', '500', '1000'],
        position: ["topRight"]
    }
}

export const getFilterParams = (searchParams) => {
    return searchParams.get("filters") ? JSON.parse(searchParams.get("filters")) : []
}

export const getSorterParams = (searchParams) => {
    let sorter = searchParams.get("sorter")
    try {
        sorter = JSON.parse(searchParams.get("sorter"))
        return sorter
    } catch (err) {
        return []
    }
}

export const setQueryParams = (setSearchParams, filters, pagination, sorter, dateDefaultValue) => {
    let k = {
        filters: JSON.stringify(filters),
        currentPage: pagination.current,
        pageSize: pagination.pageSize,
        sorter: JSON.stringify(sorter),
        startDate: dateDefaultValue[0].toISOString(),
        endDate: dateDefaultValue[1].toISOString(),
    }
    let u = new URLSearchParams(k).toString();
    setSearchParams(u)
}

export const updateColumnsFilter = (columns, filters) => {
    let tempCols = [...columns]
    for (let filter in filters) {
        for (let col in tempCols) {
            if (tempCols[col].key == filter) {
                tempCols[col].filteredValue = filters[filter]
            }
        }
    }
    return tempCols
}